export default {"src":"https://s.sylndr.com/c-f6814a1/_next/static/media/booking-call-icon.8a2ab878.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};